import { Box, Button, Menu, MenuItem, TextField } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { useCallback, useEffect, useState, useContext } from "react";
import apiService from "../../services/api-service";
import GenericForm from "../genericForm";
import GenericFileInput from "../genericFileInput";
import { CircularProgress } from "@mui/material";
import showToast from "../../utils/toast";
// GraphQL import removed - now using REST API
import { tenant } from "../../tenant";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import { AuthContext } from "../../context";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";

export default function ExportAttachments() {
	const authContext = useContext(AuthContext);
	const [anchorEl, setAnchorEl] = useState(null);
	const [loading, setLoading] = useState(false);
	const [files, setFiles] = useState([]);
	const [categoryOption, setCategoryOption] = useState([]);
	const [downloadDates, setDownloadDates] = useState({
		start_date: "",
		end_date: "",
	});
	const [showFilters, setShowFilters] = useState(true);

	const handleSetNotification = useCallback((msg, severityType) => {
		showToast(msg, severityType);
	}, []);

	const inputFieldsTab2 = [
		{ type: "readOnly", name: "view_on_GDL", label: "Visualizzato su GDL" },
		{ type: "readOnly", name: "tags", label: "Categoria", options: categoryOption },
		{ type: "textArea", name: "description", label: "Descrizione", readOnly: true },
		{ type: "readOnly", name: "creator", label: "Creatore" },
	];

	useEffect(() => {
		apiService
			.get("/tags-management/", {}, {})
			.then((data) => {
				if (data) setCategoryOption(data);
			})
			.catch((error) => {
				console.log(error);
				handleSetNotification(
					"Qualcosa è andato storto durante il caricamento delle categorie. Riprovare più tardi, se l'errore persiste contatti il supporto tecnico segnalando l'errore #0111165339"
				);
			});
	}, [handleSetNotification]);

	const handleDownload = async (type, retryCount = 0) => {
		const MAX_RETRIES = 2;
		setLoading(true);
		const apiParams = {
			type: type,
			email: authContext.getUserEmail(),
		};

		// Add date range if provided
		if (downloadDates.start_date) {
			apiParams.start_date = downloadDates.start_date;
		}
		if (downloadDates.end_date) {
			apiParams.end_date = downloadDates.end_date;
		}

		try {
			const data = await apiService.post("/download-files-from-bucket/", {}, apiParams);
			setLoading(false);
			handleSetNotification("Riceverai a breve una email con i link dei file da scaricare", "success");
			setShowFilters(false);
		} catch (error) {
			console.error("Download error:", error);

			// Check if this is a token expired error
			const errorCode = error?.response?.data?.error_code;
			const statusCode = error?.response?.status;

			if ((errorCode === "TOKEN_EXPIRED" || statusCode === 401) && retryCount < MAX_RETRIES) {
				// Token expired - retry automatically
				console.log(`Token expired, retrying download (attempt ${retryCount + 1}/${MAX_RETRIES})...`);
				handleSetNotification(
					"Token scaduto, nuovo tentativo in corso...",
					"warning"
				);

				// Wait 1 second before retrying
				setTimeout(() => {
					handleDownload(type, retryCount + 1);
				}, 1000);
			} else {
				// Other errors or max retries reached
				setLoading(false);

				// Show specific error message if available
				const errorMessage = error?.response?.data?.message ||
					error?.response?.data?.error ||
					"Qualcosa è andato storto durante il download dei file.";

				if (retryCount >= MAX_RETRIES && (errorCode === "TOKEN_EXPIRED" || statusCode === 401)) {
					handleSetNotification(
						"Il download non è riuscito dopo diversi tentativi. Riprova più tardi o contatta il supporto tecnico.",
						"error"
					);
				} else {
					handleSetNotification(
						`${errorMessage} Se l'errore persiste contatti il supporto tecnico segnalando l'errore #0111125625335`,
						"error"
					);
				}
			}
		}
	};

	return (
		<DashboardLayout>
			<DashboardNavbar />
			<div style={{ marginTop: "35px" }}></div>
			{showFilters && (
				<MDBox
					sx={{
						p: 2,
						backgroundColor: "#f5f5f5",
						borderRadius: 2,
						marginBottom: 2,
						boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
					}}
				>
					<MDTypography sx={{ textAlign: "center", marginBottom: 0.5 }} variant="h4">
						Esporta zip
					</MDTypography>
					<MDTypography sx={{ textAlign: "center", marginBottom: 0.5 }} variant="h6">
						La data di inizio e fine del download sono opzionali.
					</MDTypography>
					<MDTypography sx={{ textAlign: "center", marginBottom: 1 }} variant="h6">
						Il file zip verrà inviato all'indirizzo email <b>{authContext.getUserEmail()}</b>.
					</MDTypography>
					<LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
						<div
							style={{
								display: "flex",
								gap: "16px",
								marginBottom: "16px",
								width: "100%",
								justifyContent: "center",
							}}
						>
							<DatePicker
								label="Data Inizio Download"
								value={downloadDates.start_date ? dayjs(downloadDates.start_date) : null}
								onChange={(newValue) => {
									const formattedDate = newValue ? dayjs(newValue).format("YYYY-MM-DD") : null;
									setDownloadDates({ ...downloadDates, start_date: formattedDate });
								}}
								renderInput={(params) => (
									<TextField
										{...params}
										name="start_date"
										error={true}
										onChange={(e) => {
											const parsedDate = dayjs(e.target.value, "DD-MM-YYYY");
											if (parsedDate.isValid()) {
												setDownloadDates({
													...downloadDates,
													start_date: parsedDate.format("DD-MM-YYYY"),
												});
											}
										}}
									/>
								)}
								inputFormat="DD-MM-YYYY"
							/>
							<DatePicker
								label="Data Fine Download"
								value={downloadDates.end_date ? dayjs(downloadDates.end_date) : null}
								onChange={(newValue) => {
									const formattedDate = newValue ? dayjs(newValue).format("YYYY-MM-DD") : null;
									setDownloadDates({ ...downloadDates, end_date: formattedDate });
								}}
								renderInput={(params) => (
									<TextField
										{...params}
										name="end_date"
										error={true}
										onChange={(e) => {
											const parsedDate = dayjs(e.target.value, "DD-MM-YYYY");
											if (parsedDate.isValid()) {
												setDownloadDates({
													...downloadDates,
													end_date: parsedDate.format("DD-MM-YYYY"),
												});
											}
										}}
									/>
								)}
								inputFormat="DD-MM-YYYY"
							/>
							<div style={{}}>
								<Button
									variant="contained"
									color="primary"
									id="download-button-tab2"
									aria-controls="download-menu-tab2"
									aria-haspopup="true"
									onClick={(e) => setAnchorEl(e.currentTarget)}
									disabled={loading}
									style={{ marginBottom: "15px", color: "white" }}
								>
									{loading ? <CircularProgress size={20} /> : "Scarica files"}
								</Button>
								<Menu
									id="download-menu-tab2"
									anchorEl={anchorEl}
									keepMounted
									open={Boolean(anchorEl)}
									onClose={() => setAnchorEl(null)}
								>
									<MenuItem
										onClick={() => {
											handleDownload("all");
											setAnchorEl(null);
										}}
									>
										Scarica tutto
									</MenuItem>
									<MenuItem
										onClick={() => {
											handleDownload("images");
											setAnchorEl(null);
										}}
									>
										Scarica immagini
									</MenuItem>
									<MenuItem
										onClick={() => {
											handleDownload("videos");
											setAnchorEl(null);
										}}
									>
										Scarica video
									</MenuItem>
									<MenuItem
										onClick={() => {
											handleDownload("documents");
											setAnchorEl(null);
										}}
									>
										Scarica documenti
									</MenuItem>
								</Menu>
							</div>
						</div>
					</LocalizationProvider>
				</MDBox>
			)}
			<Box sx={{ display: "flex", gap: 2, mb: 2, mt: 1, justifyContent: "center" }}>
				<Button
					startIcon={<FilterListIcon />}
					variant="contained"
					color="primary"
					onClick={() => setShowFilters(!showFilters)}
					sx={{
						backgroundColor: "#514f4f",
						color: "#ffffff",
					}}
				>
					{showFilters ? "Nascondi Filtri" : "Mostra Filtri"}
				</Button>
			</Box>
			<GenericForm
				useSaveMethod={false}
				inputFields={[
					{
						type: "autocomplete",
						name: "tags",
						label: "Categoria",
						options: categoryOption,
						valueToDisplay: (value, options) => {
							if (typeof value === "object") {
								return `${value.label}`;
							}
							const option = options.find((opt) => opt.value === value);
							return option ? `${option.label}` : "opzione non trovata";
						},
						valueToSave: (selected) => {
							if (Array.isArray(selected)) {
								const existingIds = new Set(selected.map((opt) => (typeof opt === "object" ? opt.value : opt)));
								return Array.from(existingIds);
							}
							return selected?.value;
						},
						valueComparator: (option, value) => {
							if (typeof value === "number") {
								return option.value === value;
							}
							return option.value === value.value;
						},
					},
				]}
				executeOnChange={true}
				executeOnChangeTask={(formData) => {
					setLoading(true);
					apiService
						.get(
							"/journal-attachments-managment",
							{
								filters: true,
								area_id: localStorage.getItem("areaSelected"),
								tags: formData.tags,
								tenant:
									window.location.hostname.split(".")[0] !== "localhost"
										? process.env.REACT_APP_API_URL_BACKEND
										: "http://bottoli.localhost:8000",
							},
							{}
						)
						.then((data) => {
							setFiles(data);
							setLoading(false);
						})
						.catch((error) => {
							handleSetNotification(
								"Qualcosa è andato storto durante il caricamento dei file. Riprovare più tardi, se l'errore persiste contatti il supporto tecnico segnalando l'errore #0111125625335",
								"error"
							);
							setLoading(false);
						});
				}}
			/>

			{!loading ? (
				<>
					<div style={{ marginTop: "35px" }}></div>
					<GenericFileInput
						authModelName={"ATTACHMENTAREA"}
						inputFields={inputFieldsTab2}
						files={files}
						disableUploadFiles={true}
					/>
				</>
			) : (
				<center>
					<CircularProgress size={80} sx={{ marginTop: "50px" }} />
				</center>
			)}
		</DashboardLayout>
	);
}
